export default {
  state: {
    images: "",
    visible: false,
    index: 0,
  },

  mutations: {
    setImages (state, images) {
      state.images = images;
    },

    setVisibility (state, visible) {
      state.visible = visible;
    },
  },
};
